import { ChangeEvent } from 'react';

import TablePagination from '@mui/material/TablePagination';
import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid';

// https://material-ui.com/components/pagination/#controlled-pagination
export function DataGridPagination(): JSX.Element {
  const apiRef = useGridApiContext();
  const {
    pagination: { rowCount },
  } = apiRef.current.state;
  const { page, onPageChange, pageSize, onPageSizeChange } = useGridRootProps();

  return (
    <TablePagination
      component="div"
      count={rowCount}
      page={page || 0}
      onPageChange={(event, value) => {
        onPageChange?.(value, { api: apiRef.current });
      }}
      rowsPerPage={pageSize ?? 0}
      onRowsPerPageChange={(event: ChangeEvent<HTMLInputElement>) => {
        onPageSizeChange?.(Number(event.target.value), {
          api: apiRef.current,
        });
      }}
    />
  );
}

export default DataGridPagination;
